import { Spacer, SvgPlayCircle, Text, TextButton } from '@loomhq/lens';
import React from 'react';

const GetViewCTA = () => {
  return (
    <div>
      <Text>
        Slack, message or email your viewers to remind them about your Loom.
      </Text>
      <Spacer top="medium" />
      <TextButton
        icon={<SvgPlayCircle />}
        size="small"
        onClick={() => {
          document.location =
            'https://www.loom.com/share/8413d25510764fb88734f675fe8406af';
        }}
      >
        Understand video engagement
      </TextButton>
    </div>
  );
};

export default GetViewCTA;
